import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { generateBreadcrumbSchema } from "@/utils/seo";
import { SITE_URL } from "@/constants/seo";
import { useEffect } from "react";

interface BreadcrumbItem {
  name: string;
  path: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  const allItems = [{ name: "Inicio", path: "/" }, ...items];

  useEffect(() => {
    // Add breadcrumb structured data
    const schema = generateBreadcrumbSchema(
      allItems.map(item => ({
        name: item.name,
        url: `${SITE_URL}${item.path}`,
      }))
    );

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.className = "breadcrumb-schema";
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      document.querySelectorAll('script.breadcrumb-schema').forEach(el => el.remove());
    };
  }, [allItems]);

  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center space-x-2 text-sm text-muted-foreground">
        {allItems.map((item, index) => {
          const isLast = index === allItems.length - 1;
          const isFirst = index === 0;

          return (
            <li key={item.path} className="flex items-center">
              {index > 0 && <ChevronRight className="w-4 h-4 mx-2" />}
              {isLast ? (
                <span className="font-medium text-foreground" aria-current="page">
                  {item.name}
                </span>
              ) : (
                <Link
                  to={item.path}
                  className="hover:text-primary transition-colors flex items-center"
                >
                  {isFirst && <Home className="w-4 h-4 mr-1" />}
                  {item.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
